<template>
  <b-modal
    v-if="tracks != null"
    ref="modal"
    centered
    :visible="tracks.length > 0"
    @hidden="cancelModal"
    modal-class="modal-condensed"
  >
    <template slot="modal-header">
      <h1>Vocal instruments</h1>
      <div>
        <Button
          :empty="true"
          class="close-popup"
          @click.prevent="cancelModal"
        >{{ Translations.buttons.cancel }}</Button>
        <Button :empty="false" :noBorder="true" class="validate" @click.prevent="updateTracks">Done</Button>
      </div>
    </template>
    <template>
      <div class="flex-container">
        <div class="form-container search">
          <input
            v-focus
            type="text"
            maxlength="100"
            placeholder="Search vocal instruments"
            v-model="searchData.searchTerm"
          />
        </div>
        <div class="search-result">
          <WaitingBlock v-if="modalState.isLoadingVocalInstruments"></WaitingBlock>
          <template v-else-if="searchResult != null && searchResult != null && searchResult.length > 0 && filteredVocalInstruments.length > 0" >
            <div v-for="instrument in filteredVocalInstruments" :key="instrument.id" style="margin-left: 15px; margin-top: 5px">
              <div @click.prevent="toggleVocalInstrument(instrument)"  >
                <i :class="['far', selectedVocalInstruments[instrument.id] === undefined ? 'fa-square':'fa-check-square']" ></i>
                <span class="name">{{instrument.name}}</span>
              </div>
            </div>
          </template>
          <div v-else class="no-result-container">
            <header>
              <strong>No instrument matching your search criteria</strong>
            </header>
          </div>
        </div>
      </div>
    </template>
    <template slot="modal-footer">
      <div class="selection-container">
        <template v-if="selectedVocalInstrumentsData.length>0">
          <header>{{selectedVocalInstrumentsData.length}} selected vocal instruments :</header>
          <section>
            <div
              v-for="instrument in selectedVocalInstrumentsData.vocalInstruments"
              :key="instrument.id"
              :class="['badge', 'instrument-badge',{'selected' : selectedVocalInstruments[instrument.id] === undefined}]"
            >
              <span class="name">{{instrument.name}}</span>
              <span class="selector">
                <i class="fas fa-trash" @click.prevent="toggleVocalInstrument(instrument)"></i>
              </span>
            </div>
          </section>
        </template>
      </div>
    </template>
  </b-modal>
</template>

<script>
import Vue from "vue";
import Button from "@/components/common/Button";
import Bootstrap from "bootstrap-vue";
import store from "@/store";
import router from "@/router";
import Translations from "@/store/translations";
import EventBus from "@/eventbus";
import Portlet from "@/components/common/Portlet.vue";
import { HTTP } from "@/utils/http";
import Apis from "@/apis/index";
import { mapState } from "vuex";
import WaitingBlock from "@/components/common/WaitingBlock";

export default {
  name: "SelectorVocalInstruments",
  components: { Portlet, Bootstrap, Button, WaitingBlock },
  computed: {
    Translations: () => Translations,
    trackUids() {
      return this.tracks.map(track => track.uid);
    },
    selectedVocalInstrumentsData() {
      return {
        length: Object.keys(this.selectedVocalInstruments).length,
        vocalInstruments: Object.values(this.selectedVocalInstruments).sort(function(a, b) {
          return a.displayOrder - b.displayOrder;
        })
      };
    },
    filteredVocalInstruments() {
      var str = (this.searchData.searchTerm || "").trim();
      if (str == null || str == "") return this.searchResult || [];
      str = this.normalizeSearchTerm(str);
      return this.searchResult.filter(instrument => {
        return instrument.name.toLowerCase().includes(str.toLowerCase())
      })
    }
  },
  mounted() {
    this.search();
    // Set search input autofocus
  },
  directives: {
    focus: {
      // When the bound element is inserted into the DOM...
      inserted: function(el) {
        // hack to trigger inside method
        setTimeout(() => {
          el.focus();
        }, 0);
      }
    }
  },
  props: {
    stationUid: { required: true },
    multiselect: { required: false, default: true },
    noModalEdit: null,
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      modalState: {
        hasSearchProcessed: false,
        isLoadingVocalInstruments: false,
        delayedSearch: null
      },
      tracks: [],
      selectedVocalInstruments: {},
      searchResult: null,
      searchData: {
        searchTerm: "",
        pageSize: 50,
        page: 1
      },
      reducedVocalInstruments: []
    };
  },
  methods: {
    normalizeSearchTerm(str) {
      return (str || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();
    },
    // ------------------------------------------------------
    /* Start : Common Behaviour */
    // ------------------------------------------------------
    show() {
      this.$refs.modal.show();
    },
    edit(vocalInstruments) {
      this.selectedVocalInstruments = vocalInstruments && vocalInstruments.reduce((acc, item) => {
        acc[item.id] = item;
        return acc;
      }, {});

      this.show();
    },
    editForTracks(tracks) {
      var tmpvocalInstruments = {};
      this.tracks = tracks;
      if (this.tracks.length === 1) {
        for (var i = 0; i < (this.tracks[0].vocalInstruments || []).length; i++) {
          tmpvocalInstruments[this.tracks[0].vocalInstruments[i].id] = this.tracks[0].vocalInstruments[i];
        }
      }

      this.selectedVocalInstruments = tmpvocalInstruments;
      this.show();
    },
    searchDelay(delay) {
      if (this.delayedSearch != null) clearTimeout(this.delayedSearch);
      this.delayedSearch = setTimeout(this.search, delay || 150);
    },
    search() {
      this.modalState.isLoadingVocalInstruments = true;

      try {
        HTTP.get('/api/parameters/vocalInstruments' )
          .then(this.searchEnd)
          .catch(this.searchError)
          .then(this.searchCompleted);
      } catch (e) {
        console.log(e);
      }
    },
    searchEnd(response) {
      this.searchResult = response.data.dataItem;
    },
    searchError(response) {
      this.searchResult = response.data;
    },
    searchCompleted(response) {
      this.modalState.isLoadingVocalInstruments = false;
      this.modalState.hasSearchProcessed = true;
    },
    cancelModal() {
      this.modalState.hasSearchProcessed = true;
      this.searchData.searchTerm = "";
      this.$emit("onHidden");
      this.$refs["modal"].hide();
    },
    // ------------------------------------------------------
    /* End : Common Behaviour */
    // ------------------------------------------------------
    async updateTracks() {
        this.cancelModal();
        console.log(this.selectedVocalInstrumentsData)
        this.$emit("newValueVocalInstruments", "vocalInstruments", this.selectedVocalInstrumentsData.vocalInstruments);
        return;

    },
    toggleVocalInstrument(instrument) {
      // console.log(instrument);
      instrument.isSelected = !instrument.isSelected;

      if (this.selectedVocalInstruments[instrument.id] != null) {
        Vue.delete(this.selectedVocalInstruments, instrument.id);
      } else {
        if (!this.multiselect) {
          this.selectedVocalInstruments = {};
        }

        const newinstrument = instrument;
        const { id } = instrument;
        newinstrument.displayOrder = new Date().getTime();
        console.log(this.$router.history.current.name)
        if (this.$router.history.current.name !== 'LibraryAdvancedSearchQuery'){
          this.selectedVocalInstruments = { [instrument.id]: instrument };
        } else {
          this.selectedVocalInstruments = { ...this.selectedVocalInstruments, [instrument.id]: instrument };
        }

      }
    },
    toggleReducedVocalInstruments(id) {
      // if instrumentd id already in toggleList, remove it

      const isReduced =
        this.reducedVocalInstruments && this.reducedVocalInstruments.find(el => el === id);

      if (isReduced) {
        this.reducedVocalInstruments = [...this.reducedVocalInstruments].filter(el => el !== id);
        return;
      }

      this.reducedVocalInstruments = [...this.reducedVocalInstruments, id];
    },
    isVocalInstrumentReduced(id) {
      return this.reducedVocalInstruments && this.reducedVocalInstruments.includes(id);
    }
  }
};
</script>

<style lang="scss" scoped>
.instrument-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 10px;

  &.--child {
    margin-left: 10px;
    cursor: pointer;
  }
}

.no-result-container header {
  padding: 20px 25px;
}

.name {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0 1em;
}

.selector i,
.visible i {
  cursor: pointer;
}

.flex-container {
  display: flex;
  flex-direction: column;
}

.form-container {
  padding: 10px 25px;
  background: white;
}

.form-container.search {
  box-shadow: 0 5px 5px -5px #d2d2d2;
  position: sticky;
  top: 0px;
}

.search-container {
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.selection-container {
  background: white;
  max-height: 150px;
  overflow-y: auto;
  display: block;
  box-shadow: 0 -5px 5px -5px white;
  width: 100%;
}

.selection-container header {
  position: sticky;
  top: 0px;
  font-weight: 600;
  font-size: 13px;
  text-decoration: underline;
  background: white;
  padding: 10px 0;
}

.selection-container section {
  padding: 0 0;
  display: flex;
  flex-wrap: wrap;
}

.selection-container .badge {
  border-radius: 100px;
  display: inline-flex;
  padding: 5px 10px;
  color: white;
  align-items: center;
  margin: 5px;

  .name {
    flex-shrink: 0;
    width: auto;
  }
}

.far.fa-eye {
  color: white;
}

.far.fa-eye-slash {
  color: #ff2213;
}

.search-result {
  height: 400px;
  overflow: auto;
  max-height: 400px;
  overflow: auto;
}
</style>
